<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <g clip-path="url(#clip0_324_71401)">
            <path
                d="M15.2778 7.5C16.4847 7.5 17.4659 8.46148 17.4989 9.66038V10.0727C16.9516 9.67874 16.2814 9.44444 15.5556 9.44444C13.7147 9.44444 12.2222 10.9369 12.2222 12.7778C12.2222 13.4647 12.4303 14.1028 12.7864 14.6332C11.7633 15.226 10.9121 16.1432 10.434 17.27L4.72222 16.9444C3.49444 16.9444 2.5 15.95 2.5 14.7222V9.72222C2.5 8.49444 3.49444 7.5 4.72222 7.5H15.2778Z"
                fill="#E4EBFF"
            />
            <path
                d="M2.5 9.72135V5.27691C2.5 4.04913 3.49444 3.05469 4.72222 3.05469H6.89C7.56444 3.05469 8.20111 3.36023 8.62333 3.88579L9.29333 4.72135H15.2778C16.5056 4.72135 17.5 5.7158 17.5 6.94358V9.37468"
                stroke="#007AFF"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M17.4656 9.37554C17.2978 8.31443 16.3867 7.5 15.2778 7.5H4.72222C3.49444 7.5 2.5 8.49556 2.5 9.72222V14.7222C2.5 15.9489 3.49444 16.9444 4.72222 16.9444H9.69233"
                stroke="#007AFF"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M15.5556 14.4447C16.476 14.4447 17.2222 13.6984 17.2222 12.778C17.2222 11.8576 16.476 11.1113 15.5556 11.1113C14.6351 11.1113 13.8889 11.8576 13.8889 12.778C13.8889 13.6984 14.6351 14.4447 15.5556 14.4447Z"
                fill="#007AFF"
            />
            <path
                d="M17.8901 20.001H13.2211C12.7692 20.001 12.3428 19.7802 12.0797 19.4102C11.8214 19.0462 11.7541 18.5795 11.8996 18.1624C12.4421 16.6043 13.9112 15.5566 15.5557 15.5566C17.2001 15.5566 18.6692 16.6043 19.2123 18.163C19.3572 18.5796 19.2899 19.0462 19.0317 19.4103C18.7686 19.7803 18.342 20.001 17.8901 20.001Z"
                fill="#007AFF"
            />
        </g>
        <defs>
            <clipPath id="clip0_324_71401">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
